export default "__VITE_ASSET__jlyyW_ZW__"